import * as types from '../constants/ActionTypes';
import { loadChannelsFromCache, subscribeChannel, getSubscriptions } from "../services/firebase/channels";
import { deleteChannelUstream } from "../services/firebase/firebase";
import { deleteImageFromFirebase } from "../services/firebase/storage";

// === POST CHANNEL ===
export function addChannelAction(event) {
  return (dispatch) => {
    dispatch(addChannelStore(event));
  };
}

export function addChannelStore(payload) {
  return {
    type: types.ADD_CHANNEL,
    payload,
  };
}

// === GET ALL CHANNELS ===
export function getChannelsAction() {
  return (dispatch) => {
    return loadChannelsFromCache().then((channels) => {
      dispatch(addChannelsStore(channels));

      return channels
    });
  };
}

export function addChannelsStore(payload) {
  return {
    type: types.ADD_ALL_CHANNELS,
    payload,
  };
}

// === DELETE CHANNEL ===
export function deleteChannelsAction(channel) {
  return (dispatch) => {
    return deleteChannelUstream(channel).then((res) => {
      if (res.answer === 'success') {
        channel.thumbnailName && deleteImageFromFirebase(channel.thumbnailName);
        dispatch(deleteChannelsStore(channel));

        return 'success'
      }
    });
  };
}

export function deleteChannelsStore(payload) {
  return {
    type: types.DELETE_CHANNEL,
    payload,
  };
}

// === GET ALL SUBSCRIPTIONS ===
export function getSubscriptionsAction() {
  return (dispatch) => {
    return getSubscriptions().then((subscriptions) => {
      dispatch(addSubscriptionsStore(subscriptions));

      return subscriptions
    });
  };
}

export function addSubscriptionsStore(payload) {
  return {
    type: types.ADD_SUBSCRIPTIONS,
    payload,
  };
}

// === SUBSCRIBE CHANNEL ===
export function subscribeChannelAction(payload) {
  return (dispatch) => {
    dispatch(subscribeChannelStart());

    subscribeChannel(payload).then(data => {
      dispatch(subscribeChannelSuccess(payload));
    })
    .catch(error => {
      dispatch(subscribeChannelFail(error));
    });
  }
}

export function subscribeChannelStart() {
  return {
    type: types.SUBSCRIBE_CHANNEL_START
  }
}

export function subscribeChannelSuccess(payload) {
  return {
    type: types.SUBSCRIBE_CHANNEL_SUCCESS,
    payload,
  }
}

export function subscribeChannelFail(payload) {
  return {
    type: types.SUBSCRIBE_CHANNEL_FAIL,
    payload
  }
}

export function deleteContributor(payload) {
  return {
    type: types.DELETE_CONTRIBUTOR,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/channelsStoreActions.js